import React from 'react'
import { tierAccessLabel, tierActionLabel } from './parentBillingDisplay'

export const BillingSummaryNotice = ({ onDismiss }) => (
  <div className="parent-billing-summary-error" role="alert">
    <span className="parent-billing-summary-error-text">Couldn't load tiers.</span>
    <button
      type="button"
      className="parent-billing-summary-dismiss"
      onClick={onDismiss}
    >
      Dismiss
    </button>
  </div>
)

const ManageTiers = ({
  loading,
  rows,
  summaryFailed,
  onDismissSummaryError,
  onOpen
}) => {
  if (loading) {
    return (
      <div className="parent-desktop-main-content">
        <div className="parent-desktop-loading">Loading students...</div>
      </div>
    )
  }

  return (
    <div className="parent-desktop-main-content">
      {summaryFailed && (
        <div className="parent-billing-summary-error-slot">
          <BillingSummaryNotice onDismiss={onDismissSummaryError} />
        </div>
      )}
      <div className="parent-desktop-students-browser parent-desktop-settings-browser">
        {rows.length === 0 ? (
          <div className="parent-desktop-empty-state">
            <p>No students linked to your account yet.</p>
            <p className="parent-desktop-empty-subtitle">Create a student account or share your parent code to link accounts.</p>
          </div>
        ) : (
          <div className="parent-desktop-settings-content">
            <div className="parent-desktop-settings-section">
              {rows.map((row) => {
                const label = row.summary ? tierAccessLabel(row.summary.access) : null
                const action = row.summary ? tierActionLabel(row.summary.access) : null
                return (
                  <div key={row.id} className="parent-desktop-settings-item">
                    <div className="parent-desktop-settings-label">
                      <div>{row.displayName}</div>
                      {label && (
                        <div className="parent-desktop-student-email">{label}</div>
                      )}
                    </div>
                    {action && (
                      <div className="parent-desktop-settings-control">
                        <button
                          type="button"
                          className="save-button parent-settings-action-btn"
                          aria-label={`${action} ${row.displayName}`}
                          onClick={() => onOpen(row.id)}
                        >
                          {action}
                        </button>
                      </div>
                    )}
                  </div>
                )
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default ManageTiers
